/* Kruikenland — pzf.js */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.add('pzf');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var GIFT_KEY = 'Gratis cadeau';
  var GIFTS = {
    korrels: 'Gebreide hoes',
    speeltje: 'Teddy hoes'
  };
  function giftKeyFromValue(v) {
    for (var k in GIFTS) { if (GIFTS[k] === v) return k; }
    return null;
  }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- geld ---------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + v[0] + ',' + v[1];
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- scroll-voortgang ---------- */
  var bar = document.querySelector('.pzf-progress');
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (bar) {
        var h = document.documentElement.scrollHeight - innerHeight;
        bar.style.setProperty('--p', h > 0 ? Math.min(1, scrollY / h) : 0);
      }
      exploded.forEach(function (x) { x.update(); });
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- reveal ---------- */
  var rv = document.querySelectorAll('[data-pzf-rv]');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    rv.forEach(function (el) { io.observe(el); });
  } else { rv.forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- tellers ---------- */
  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-pzf-count')); if (isNaN(to)) return;
    if (reduce) { el.textContent = el.getAttribute('data-pzf-count'); return; }
    var start = null, dur = 1400;
    function step(t) {
      if (!start) start = t;
      var k = Math.min(1, (t - start) / dur); k = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(to * k);
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    var co = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); co.unobserve(e.target); } });
    });
    document.querySelectorAll('[data-pzf-count]').forEach(function (el) { co.observe(el); });
  }

  /* ---------- 3D-tilt hero ---------- */
  document.querySelectorAll('[data-pzf-tilt]').forEach(function (stage) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    var inner = stage.querySelector('.pzf-stage__tilt');
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      inner.style.transform = 'rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 12) + 'deg)';
    });
    stage.addEventListener('pointerleave', function () { inner.style.transform = ''; });
  });

  /* ---------- spotlight op kaarten ---------- */
  document.querySelectorAll('.pzf-card').forEach(function (c) {
    c.addEventListener('pointermove', function (e) {
      var r = c.getBoundingClientRect();
      c.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      c.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  });

  /* ---------- uit-elkaar-weergave ---------- */
  var exploded = [];
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  document.querySelectorAll('[data-pzf-x]').forEach(function (sec) {
    var parts = Array.prototype.slice.call(sec.querySelectorAll('[data-pzf-part]'));
    var labels = sec.querySelectorAll('[data-pzf-label]');
    var mobile = sec.querySelectorAll('[data-pzf-mlabel]');
    var hud = sec.querySelector('[data-pzf-x-hud]');
    var toggle = sec.querySelector('[data-pzf-x-toggle]');
    var forced = null;
    var self = {
      set: function (p) {
        var e = ease(Math.max(0, Math.min(1, p)));
        parts.forEach(function (g) {
          var dx = parseFloat(g.getAttribute('data-dx') || 0) * e;
          var dy = parseFloat(g.getAttribute('data-dy') || 0) * e;
          var rot = parseFloat(g.getAttribute('data-rot') || 0) * e;
          var sc = 1 + (parseFloat(g.getAttribute('data-s') || 1) - 1) * e;
          var cx = g.getAttribute('data-cx') || 320, cy = g.getAttribute('data-cy') || 330;
          g.setAttribute('transform', 'translate(' + dx.toFixed(1) + ' ' + dy.toFixed(1) + ') translate(' + cx + ' ' + cy + ') scale(' + sc.toFixed(3) + ') rotate(' + rot.toFixed(2) + ') translate(' + (-cx) + ' ' + (-cy) + ')');
        });
        var active = -1;
        labels.forEach(function (l, i) {
          var on = e > 0.18 + i * 0.13;
          l.classList.toggle('is-on', on);
          if (on) active = i;
        });
        mobile.forEach(function (m, i) { m.classList.toggle('is-on', i === active); });
        parts.forEach(function (g) { g.classList.toggle('is-hot', active >= 0 && g.getAttribute('data-pzf-part') === String(active)); });
        sec.style.setProperty('--p', e.toFixed(3));
        if (hud) hud.textContent = e > .95 ? 'Volledig uit elkaar' : (e < .05 ? 'In elkaar' : Math.round(e * 100) + '% uit elkaar');
        sec.classList.toggle('is-done', e > .95);
        if (toggle) toggle.textContent = e > .5 ? 'Zet in elkaar' : 'Haal uit elkaar';
      },
      update: function () {
        if (forced !== null) return;
        if (reduce) { self.set(1); return; }
        var r = sec.getBoundingClientRect();
        var total = r.height - innerHeight;
        var p = total > 0 ? (-r.top) / total : 1;
        self.set((p - .08) / .72);
      }
    };
    if (toggle) toggle.addEventListener('click', function () {
      var cur = parseFloat(sec.style.getPropertyValue('--p')) || 0;
      var target = cur > .5 ? 0 : 1, from = cur, t0 = null;
      forced = from;
      function anim(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / 900);
        self.set(from + (target - from) * k);
        if (k < 1) requestAnimationFrame(anim);
        else setTimeout(function () { forced = null; }, 1500);
      }
      requestAnimationFrame(anim);
    });
    exploded.push(self);
    self.update();
  });

  /* ---------- verwachte levering (2-4 werkdagen, verzending op werkdagen) ---------- */
  document.querySelectorAll('[data-pzf-eta]').forEach(function (el) {
    var days = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
    var months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
    function addWork(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; }
    var now = new Date();
    var ship = new Date(now);
    if (ship.getDay() === 0 || ship.getDay() === 6) ship = addWork(ship, 1);
    var a = addWork(ship, 2), b = addWork(ship, 4);
    function f(d) { return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]; }
    var out = el.querySelector('[data-pzf-eta-text]');
    if (out) out.innerHTML = 'Verwachte levering tussen <b>' + f(a) + '</b> en <b>' + f(b) + '</b>';
  });

  /* ---------- cadeaukeuze ---------- */
  function currentGift() { return store('pzf-gift') || 'korrels'; }
  function syncGiftInputs(key) {
    document.querySelectorAll('input[data-pzf-gift]').forEach(function (i) { i.checked = i.value === key; });
    document.querySelectorAll('[data-pzf-gift-name]').forEach(function (n) { n.textContent = key === 'speeltje' ? 'Gratis teddy hoes' : 'Gratis gebreide hoes'; });
  }
  var curEl = document.querySelector('[data-pzf-gift-current]');
  if (curEl && curEl.getAttribute('data-pzf-gift-current')) store('pzf-gift', curEl.getAttribute('data-pzf-gift-current'));
  syncGiftInputs(currentGift());
  document.addEventListener('change', function (e) {
    var i = e.target.closest && e.target.closest('input[data-pzf-gift]');
    if (!i) return;
    store('pzf-gift', i.value);
    syncGiftInputs(i.value);
    if (cartState && cartState.item_count > 0) setGift(i.value).then(renderCart);
    var pageForm = i.closest('form[data-cart-form]');
    if (pageForm) {
      var hidden = pageForm.querySelector('input[name="attributes[' + GIFT_KEY + ']"]');
      if (hidden) hidden.value = GIFTS[i.value];
      var upd = pageForm.querySelector('[name="update"]');
      if (pageForm.requestSubmit && upd) pageForm.requestSubmit(upd);
    }
  });
  function setGift(key) {
    var attrs = {}; attrs[GIFT_KEY] = GIFTS[key] || GIFTS.korrels;
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function (r) { return r.json(); }).then(function (c) { cartState = c; return c; });
  }

  /* ---------- winkelwagen-lade ---------- */
  var drawer = document.querySelector('[data-pzf-cart]');
  var cartState = null;
  var lastFocus = null;
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cartState = c; return c; });
  }
  function updateCount(n) {
    document.querySelectorAll('.header__icons a[href$="/cart"]').forEach(function (a) {
      var badge = a.querySelector('.cart-count');
      if (n > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count'; badge.setAttribute('aria-hidden', 'true'); a.appendChild(badge); }
        badge.textContent = n; badge.classList.remove('pzf-bump'); void badge.offsetWidth; badge.classList.add('pzf-bump');
      } else if (badge) { badge.remove(); }
    });
    var c = drawer && drawer.querySelector('[data-pzf-count]');
    if (c) c.textContent = n;
  }
  function giftLine(cart) {
    var key = giftKeyFromValue(cart.attributes && cart.attributes[GIFT_KEY]) || currentGift();
    var tpl = drawer.querySelector('template[data-pzf-gift-art="' + key + '"]');
    var art = tpl ? tpl.innerHTML : '';
    return '<li class="pzf-line pzf-line--gift"><div class="pzf-line__img">' + art + '</div><div><span class="pzf-line__title">' +
      (key === 'speeltje' ? 'Gratis teddy hoes' : 'Gratis gebreide hoes') + '</span><span style="font-size:.78rem;color:rgba(31,27,22,.6)">Cadeau bij je kruik</span></div><div class="pzf-line__price">Gratis</div></li>';
  }
  function renderCart(cart) {
    if (!drawer) return;
    cart = cart || cartState;
    drawer.classList.toggle('is-empty', !cart.item_count);
    updateCount(cart.item_count);
    var list = drawer.querySelector('[data-pzf-items]');
    var html = cart.items.map(function (it, idx) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var cmp = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<li class="pzf-line" data-line="' + (idx + 1) + '">' +
        '<a class="pzf-line__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="76" height="76">' : '') + '</a>' +
        '<div><a class="pzf-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<div class="pzf-line__meta"><div class="pzf-qty"><button type="button" data-pzf-q="-1" aria-label="Minder">−</button><span>' + it.quantity + '</span><button type="button" data-pzf-q="1" aria-label="Meer">+</button></div>' +
        '<button type="button" class="pzf-line__rm" data-pzf-rm>Verwijderen</button></div></div>' +
        '<div class="pzf-line__price">' + cmp + money(it.final_line_price) + '</div></li>';
    }).join('');
    if (cart.item_count && window.KL_GIFT) html += giftLine(cart);
    list.innerHTML = html;
    var sub = drawer.querySelector('[data-pzf-sub]'); if (sub) sub.textContent = money(cart.total_price);
    var key = giftKeyFromValue(cart.attributes && cart.attributes[GIFT_KEY]);
    if (key) { store('pzf-gift', key); syncGiftInputs(key); }
  }
  function openCart() {
    if (!drawer) { window.location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('.pzf-cart__close'); if (close) close.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function change(line, qty) {
    drawer.classList.add('is-busy');
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (c) { cartState = c; renderCart(c); })
      .finally(function () { drawer.classList.remove('is-busy'); });
  }
  function toast(msg) {
    var t = document.querySelector('.pzf-toast');
    if (!t) { t = document.createElement('div'); t.className = 'pzf-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  function addToCart(body, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        return getCart().then(function (c) {
          var want = GIFTS[currentGift()];
          if (window.KL_GIFT && (!c.attributes || c.attributes[GIFT_KEY] !== want)) return setGift(currentGift());
          return c;
        });
      })
      .then(function (c) {
        renderCart(c); openCart();
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1800); }
        if (window.Shopify && typeof window.Shopify.analytics === 'object') { /* Shopify-pixels volgen cart-events zelf */ }
      })
      .catch(function (err) {
        if (btn) btn.classList.remove('is-loading');
        toast((err && (err.description || err.message)) || 'Er ging iets mis. Probeer het opnieuw.');
      });
  }

  if (drawer) {
    getCart().then(renderCart).catch(function () {});
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-pzf-cart-close]')) { e.preventDefault(); closeCart(); return; }
      var line = e.target.closest('[data-line]');
      if (!line) return;
      var n = parseInt(line.getAttribute('data-line'), 10);
      var item = cartState && cartState.items[n - 1]; if (!item) return;
      if (e.target.closest('[data-pzf-rm]')) change(n, 0);
      var q = e.target.closest('[data-pzf-q]');
      if (q) change(n, Math.max(0, item.quantity + parseInt(q.getAttribute('data-pzf-q'), 10)));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart(); });

    /* headericoon opent de lade */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href$="/cart"]');
      if (!a || a.closest('[data-pzf-cart]') || e.metaKey || e.ctrlKey) return;
      if (location.pathname.replace(/\/$/, '').slice(-5) === '/cart') return;
      e.preventDefault(); getCart().then(renderCart); openCart();
    });

    /* productformulieren via AJAX */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var btn = f.querySelector('[type="submit"][name="add"], button[type="submit"]');
      addToCart(new FormData(f), btn);
    }, true);
    var nativeSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (this.action && this.action.indexOf('/cart/add') > -1) { addToCart(new FormData(this), this.querySelector('button[type="submit"]')); return; }
      return nativeSubmit.apply(this, arguments);
    };

    /* snelle knoppen */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pzf-add]');
      if (!b) return;
      e.preventDefault();
      var fd = new FormData(); fd.append('id', b.getAttribute('data-pzf-add')); fd.append('quantity', '1');
      addToCart(fd, b);
    });
  }

  /* ---------- uit-elkaar-sectie verplaatsen naar onder het product ---------- */
  document.querySelectorAll('[data-pzf-move-after]').forEach(function (el) {
    var host = el.closest('.shopify-section') || el;
    var target = document.querySelector(el.getAttribute('data-pzf-move-after'));
    if (target) {
      var t = target.closest('.shopify-section') || target;
      t.parentNode.insertBefore(host, t.nextSibling);
      onScroll();
    }
  });
})();
